import { forwardRef } from 'react';
import type { ElementRef, ComponentPropsWithoutRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';

import style from './select-compound.module.scss';

const SelectValue = forwardRef<
  ElementRef<typeof SelectPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(({ ...props }, ref) => (
  // Since we cannot add styles to the SelectPrimitive.Value, we need to wrap it in a span
  // specifically for truncating the text.
  // For the reason why we cannot add styles to the SelectPrimitive.Value, please refer to:
  // https://github.com/radix-ui/primitives/issues/1363
  <span className={style.SelectValue}>
    <SelectPrimitive.Value
      ref={ref}
      {...props}
    />
  </span>
));
SelectValue.displayName = SelectPrimitive.Value.displayName;

export { SelectValue };
